import React, { useRef, useState } from "react";
import UploadExcel from "../MakerProgressBar/UploadExcel";
import PreviewDocuments from "../MakerProgressBar/PreviewDocuments";
import ReviewSubmit from "../MakerProgressBar/ReviewSubmit";
import Confirmation from "../MakerProgressBar/Confirmation"

function NewUpload({ setActiveTab }) {

  const [step, setStep] = useState(1);
  const fileInputRef = useRef(null);
  const [uploadedData, setUploadedData] = useState(null);
  const [confirmationData, setConfirmationData] = useState(null);

  const handleFileUpload = (fileData) => {
    // setUploadedData(fileData);
    setStep(2);
  };

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 4));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="new-upload">
      <div className="progress-bar">
        <div className={`progress-step ${step > 1 ? "completed" : ""} ${step === 1 ? "active" : ""}`}>
          <div className={`${step === 1 ? "pending-state" : ""}`}>
            <span className="circle">1</span>
          </div>
          <span className="label">Upload Excel</span>
        </div>
        <div className={`progress-line ${step > 1 ? "active" : ""}`}></div>
        <div className={`progress-step ${step > 2 ? "completed" : ""} ${step === 2 ? "active" : ""}`}>
          <div className={`${step === 2 ? "pending-state" : ""}`}>
            <span className="circle">2</span>
          </div>
          <span className="label">Preview Documents</span>
        </div>
        <div className={`progress-line ${step > 2 ? "active" : ""}`}></div>
        <div className={`progress-step ${step > 3 ? "completed" : ""} ${step === 3 ? "active" : ""}`}>
          <div className={`${step === 3 ? "pending-state" : ""}`}>
            <span className="circle">3</span>
          </div>
          <span className="label">Review & Submit</span>
        </div>
        <div className={`progress-line ${step > 3 ? "active" : ""}`}></div>
        <div className={`progress-step ${step > 4 ? "completed" : ""} ${step === 4 ? "active" : ""}`}>
          <div className={`${step === 4 ? "pending-state" : ""}`}>
            <span className="circle">4</span>
          </div>
          <span className="label">Confirmation</span>
        </div>
      </div>

      <div className="wrap-all-tabs">
        {step === 1 && 
        <UploadExcel 
          onUpload={handleFileUpload} 
        />}

        {step === 2 && 
        <PreviewDocuments 
          onNext={() => setStep(3)} 
          onBack={() => setStep(1)} 
          setUploadedData={setUploadedData} 
          />}

        {step === 3 && 
        <ReviewSubmit 
          data={uploadedData} 
          onBack={() => setStep(2)} 
          onSubmit={(data) => {
          setConfirmationData(data);
          setStep(4);
        }} />}

        {step === 4 && (
          <Confirmation
            onNewUpload={() => setStep(1)}
            setActiveTab={setActiveTab}
            confirmationData={confirmationData}
          />
        )}
      </div>

    </div>
  );
}

export default NewUpload;
